// @flow
import api from './';

export function get401(){
  return api('get', `/api/v1/401`)
}
